define([
	"dojo/_base/declare",
	"underscore",
	"csi",
	"csi/toolbar/CheckedMenuItem",
	"./_CustomViewAction"
], function(declare,_,csi,CheckedMenuItem,_CustomViewAction) {

	return declare(_CustomViewAction, {
		classController: "csi/view/customview/ShareWithController",
		customViewDirty: false,
		customViewInstance: true,
		shareWith: null,

		classToolbarPlugin: CheckedMenuItem,
		classToolbarPluginParams: {
			"class": "csi-menu-item-with-icon",
			iconClass: "csi-checked-menu-item-check",
			bDisableChecked: false,
			testCheckedFunction: function(ctx) {
				// checked will be true if selected view's party is the same as the party represented by action (shareWith)
				var shareWith = this.defAction.shareWith
				var	cv = ctx.view.getSelectedCustomView();
				return cv && (cv.isSharedWithRole(shareWith) || (cv.isSystemWide() && (shareWith == csi.EMPTY_URL)));
			}
		}
	});
});